import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith('/ops') || location.pathname === '/blueprint' || location.pathname === '/capture') return null;

  return (
    <footer className="bg-slate-950 text-slate-400 mt-auto relative noise-overlay overflow-hidden" data-testid="main-footer">
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-7 h-7 rounded-full bg-white text-slate-900 flex items-center justify-center text-xs font-bold">B</div>
              <span className="text-[15px] font-semibold text-white">Buy In Burlington</span>
            </div>
            <p className="text-[13px] text-white/30 leading-relaxed">
              Get a tailored overview of <Link to="/burlington-on" className="text-white/50 hover:text-white transition-colors underline decoration-white/20 hover:decoration-white/50">Burlington, Ontario</Link> neighbourhoods.
            </p>
          </div>

          <div>
            <p className="text-[10px] font-semibold tracking-widest uppercase text-white/20 mb-4">Explore</p>
            <div className="flex flex-col gap-2.5">
              <Link to="/neighbourhoods" className="text-[13px] text-white/40 hover:text-white transition-colors">Neighbourhoods</Link>
              <Link to="/schools" className="text-[13px] text-white/40 hover:text-white transition-colors">Schools</Link>
              <Link to="/relocation" className="text-[13px] text-white/40 hover:text-white transition-colors">Relocation</Link>
              <Link to="/budget" className="text-[13px] text-white/40 hover:text-white transition-colors">Budget</Link>
              <Link to="/guides" className="text-[13px] text-white/40 hover:text-white transition-colors">All Guides</Link>
            </div>
          </div>

          <div>
            <p className="text-[10px] font-semibold tracking-widest uppercase text-white/20 mb-4">Get Started</p>
            <div className="flex flex-col gap-2.5">
              <Link to="/blueprint" className="text-[13px] text-white/40 hover:text-white transition-colors">Buyer Blueprint</Link>
              <Link to="/neighbourhoods" className="text-[13px] text-white/40 hover:text-white transition-colors">Compare Areas</Link>
            </div>
          </div>

          <div>
            <p className="text-[10px] font-semibold tracking-widest uppercase text-white/20 mb-4">Legal</p>
            <div className="flex flex-col gap-2.5">
              <Link to="/privacy" className="text-[13px] text-white/40 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="text-[13px] text-white/40 hover:text-white transition-colors">Terms of Service</Link>
              <button onClick={() => { localStorage.removeItem('bib_cookie_consent'); window.location.reload(); }} className="text-[13px] text-white/40 hover:text-white transition-colors text-left" data-testid="manage-cookies-link">
                Manage Cookie Preferences
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[11px] text-white/20">&copy; {new Date().getFullYear()} Buy In Burlington. All rights reserved.</p>
          <p className="text-[11px] text-white/15 max-w-lg text-right">
            Disclaimer: Data is for general guidance only. School boundaries, pricing, and availability should be independently verified. Not financial or legal advice.
          </p>
        </div>
      </div>
    </footer>
  );
}
